import { Link } from "react-router-dom";
import { genres } from "@/mocks/genres";

export default function CategoryQuick() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            分类快捷入口
          </h2>
          <p className="mt-1 text-sm text-foreground-600">按类型快速找到你想看的故事</p>
        </div>
        <Link
          to="/category/action"
          className="hidden items-center gap-1 whitespace-nowrap text-sm text-accent-500 transition-colors hover:text-accent-400 sm:flex"
        >
          全部分类
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      </div>

      <div className="flex gap-3 overflow-x-auto pb-2 no-scrollbar md:grid md:grid-cols-6 md:gap-4 md:overflow-visible">
        {genres.map((g) => (
          <Link
            key={g.slug}
            to={`/category/${g.slug}`}
            className="group flex w-[130px] shrink-0 flex-col items-center gap-3 rounded-lg border border-background-200/60 bg-background-100 px-4 py-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-500/60 md:w-auto"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500/15 text-primary-300 transition-colors group-hover:bg-accent-500 group-hover:text-background-950">
              <i className={`${g.icon} text-2xl`}></i>
            </span>
            <span className="text-sm font-medium text-foreground-900">{g.name}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}